import { apiClient } from "../../../services/axiosInstance";
import type { ServerListResponse, Section } from "../../../types";
import type {
  SearchContext,
  SearchSuggestItem,
  SearchQueryResponse,
  SearchQueryParams,
} from "../types";

// React Query keys
export const SEARCH_SUGGEST_KEY = ["search-suggest"];
export const SEARCH_QUERY_KEY = ["search-query"];
export const SEARCH_BROWSE_SECTIONS_KEY = ["search-browse-sections"];

// --- Helpers ---

export function buildSearchQueryParams(
  params: SearchQueryParams,
): URLSearchParams {
  const sp = new URLSearchParams();

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;

    if ((key === "lang_id" || key === "country_id") && Array.isArray(value)) {
      for (const id of value) {
        sp.append(`${key}[]`, String(id));
      }
    } else if (key === "facets" && typeof value === "object" && !Array.isArray(value)) {
      for (const [groupId, optionIds] of Object.entries(value as Record<string, string[]>)) {
        for (const optionId of optionIds) {
          sp.append(`facets[${groupId}][]`, optionId);
        }
      }
    } else if (typeof value === "boolean") {
      sp.set(key, value ? "1" : "0");
    } else {
      sp.set(key, String(value));
    }
  }

  return sp;
}

// --- API functions ---

export function searchSuggest(
  q: string,
  context?: SearchContext,
  signal?: AbortSignal,
) {
  const sp = new URLSearchParams({ q });
  if (context) sp.set("context", context);

  return apiClient.get<ServerListResponse<SearchSuggestItem>>(
    `/v1/search/suggest?${sp}`,
    { signal },
  );
}

export function searchQuery(
  params: SearchQueryParams,
  signal?: AbortSignal,
) {
  const sp = buildSearchQueryParams(params);

  return apiClient.get<SearchQueryResponse>(
    `/v1/search/query${sp.size > 0 ? "?" + sp : ""}`,
    { signal },
  );
}

export function getSearchBrowseSections(
  context: string,
  signal?: AbortSignal,
) {
  return apiClient.get<ServerListResponse<Section>>(
    `/v1/cms/_internal.gc.app.search.browse.${context}/sections`,
    { signal },
  );
}
